<template>
	<div class="jiangli">
		<div class="jiangli_top">
			<img @click="fanhui()" src="../../assets/images/licai/fanhui.png"/>
			<p class="">奖金制度</p>
		</div>
		<div class="jiangli_con">
			<div class="jiangli_con_cnt">
				<h4>个人推广奖励说明:</h4>
				
				 <p class="">特别说明：老会员成功邀请新会员注册开户，新会员注册成功充值并投资的，老会员可得到相应的提成！</p>
				
				<h4>一、邀请佣金制度说明：</h4>
				
				<p class="">1、邀请新会员，注册成功并投资后，可得到系统分配的邀请佣金；</p>
				<p class="">2、邀请新会员，最多可到D级，每成功邀请一位会员，都可以得到其投资的邀请佣金，并且可享受一次邀请，终生分配佣金的福利；</p>
				<p class="">3、新会员权利，被邀请加入的新会员，继续邀请新会员注册成功并投资后，仍然可以享受一次邀请，终生分配佣金的福利；</p>
				<p class="">4、邀请佣金，全程由系统自动结算，新会员投资后，即刻结算；</p>
				<p class="">5、佣金金额，无封顶限制，即被邀请会员投资金额无论多少，邀请者均可得到相应比例的佣金。</p>
				 
				 
				<h4> 二、分配级别及佣金说明：</h4>
				 
			    <p class=""> 邀请关系建立后，即被邀请人成功注册并投资后，邀请人最低可得到被邀请人投资产品金额的佣金；</p>
				<p class=""> 为说明级别关系，如下，假设您为注册会员A,进行详细说明：</p>
				<p class=""> 1、当您邀请了B，B是您的第一级下属，您能得到B投资金额的6%邀请佣金；</p>
				<p class=""> 2、当B邀请了C，C是您的第二级下属，您能得到C投资金额的3%分红；</p>
				<p class=""> 3、当C邀请了D，D是您的第三级下属，您能得到D投资金额的2%分红；</p>
				<p class=""> 为了更直观的看到您的佣金收益，我们分别假设为B投资额为10000元，C投资也为10000元等等。在这样的情况下，您的收益情况如下：</p>
				<p class=""> B投资10000元×6% = 您获得600元；</p>
				<p class=""> C投资10000元×3% = 您获得300元；</p>
				<p class=""> D投资10000元×2% = 您获得200元；</p>
				<p class=""> 邀请佣金 = B+C+D=600+300+200=1100元</p>
				<p class="">  注：邀请佣金奖励只奖励下三层下属，与您一起市场共享，互惠共赢！</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "jiangli",
		data: function() {
			return {
				types:0,
			};
		},
		created() {
	
		},
		mounted: function() {
			
		},
		methods: {
			fanhui:function(){
				this.$router.push({
					path:'/'
				})
			}
		},
	};
</script>
<style>
	h4{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 43px;
		opacity: 0.99;
	}
	.jiangli_con_cnt p{
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		line-height: 28px;
		opacity: 0.99;
	}
	.jiangli_con{padding: 30px 15px;}
	.jiangli_top{
		width: 100%;
		height: 45px;
		line-height: 45px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.jiangli_top img{
		height: 30px;
		width: 30px;
		position: absolute;left: 0px;
	}
	.jiangli_top p{
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333!important;
		text-align: center;
	}
</style>
